/**
 * The arrows of blocks/mm-person.liquid: each moves its person's photo row by
 * most of a view, smoothly. They show only while some photo is out of view and
 * go dim at either end, as the arrows of «Llevan puesto MM». Swiping the row on
 * a phone still works; the arrows are for a mouse.
 */

function wire(person) {
  const row = person.querySelector('.mm-person__photos');
  const arrows = person.querySelector('.mm-person__arrows');
  if (!row || !arrows || person.dataset.mmPersonWired) return;
  person.dataset.mmPersonWired = 'true';

  const previous = arrows.querySelector('[data-mm-person-step="-1"]');
  const next = arrows.querySelector('[data-mm-person-step="1"]');

  const update = () => {
    const overflow = row.scrollWidth - row.clientWidth > 1;
    arrows.hidden = !overflow;
    if (previous instanceof HTMLButtonElement) previous.disabled = row.scrollLeft <= 1;
    if (next instanceof HTMLButtonElement) next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
  };

  arrows.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-mm-person-step]') : null;
    if (!button) return;
    const step = Number(button.getAttribute('data-mm-person-step'));
    row.scrollBy({ left: step * row.clientWidth * 0.8, behavior: 'smooth' });
  });

  row.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(row);
  row.querySelectorAll('img').forEach((img) => img.addEventListener('load', update, { once: true }));
  update();
}

document.querySelectorAll('.mm-person').forEach(wire);
document.addEventListener('shopify:section:load', () => document.querySelectorAll('.mm-person').forEach(wire));
